export const TYPES = {
  SET_GIFT_CARD_INFOS: "SET_GIFT_CARD_INFOS",
};

export function setGiftCardInfos(giftCardInfos) {
  return (dispatch) => {
    dispatch({ type: TYPES.SET_GIFT_CARD_INFOS, giftCardInfos });
  };
}
